/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Scenting_Log_Stale_ClientInputs */

const vi_error_scenting_log_stale_client = /** @type {(inputs: Error_Scenting_Log_Stale_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang sổ đang là bản cũ nên không sửa được mẻ có nhiều loại hoặc chè tấm. Tải lại trang rồi sửa lại.`)
};

/**

* @param {Error_Scenting_Log_Stale_ClientInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_scenting_log_stale_client = /** @type {((inputs?: Error_Scenting_Log_Stale_ClientInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Scenting_Log_Stale_ClientInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_scenting_log_stale_client(inputs)
});